export enum CheckboxThemes {
  Primary = 'primary',
  Classic = 'classic',
  Dark = 'dark',
  Blue = 'blue'
}
